export const baseUrls = "https://msparc-backend.up.railway.app";
//export const baseUrls = "http://localhost:8080";
export const itemPerPage = 20;
export const pageMaxSize = 2000
export const pageSizeOptions = [5, 10, 20, 50, 100];
